(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {FABRICS,LENGTHS,HEAD_WIDTHS,FOOT_WIDTHS,GROUND_HARDWARE,RIDGELINE_LOOPS,BIVY_LOOPS,GLOWIRE,STAKES,PATCH_KIT}=window.SLDEstimatorData.products["trail_bird"];
const CONTROLS=window.SLDEstimatorData.productControls.trailBird;

  const FIELD_LABELS = Object.freeze({
    'Fabric/Color * (required)': 'Fabric',
    'Length * (required)': 'Length',
    'Width, Head End * (required)': 'Head Width',
    'Width, Foot End * (required)': 'Foot Width',
    'Ground Tie Outs * (required)': 'Ground Hardware',
    'Intermediate Ridgeline Tie Outs * (required)': 'Ridgeline Loops',
    'Bivy Loops * (required)': 'Bivy Loops',
    "Reflective Guyline Cord * (required)": 'Glowire',
    'Tent Stakes * (required)': 'Tent Stakes',
    'Patch Kit * (required)': 'Patch Kit'
  });

  const DEFAULTS = Object.freeze({
    'Ground Hardware': 'Loops Only',
    'Ridgeline Loops': 'None',
    'Bivy Loops': 'No',
    Glowire: 'None (I will use my own)',
    'Tent Stakes': 'None (I will use my own)',
    'Patch Kit': 'No'
  });

  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const exactText = (value) => String(value || '').trim();

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label=Object.keys(FIELD_LABELS).find(key=>key.replace(/\s+/g,' ').trim()===String(element.labels&&element.labels[0]&&element.labels[0].textContent||'').replace(/\s+/g,' ').trim());
      if (!own(FIELD_LABELS, label)) continue;
      selected[FIELD_LABELS[label]] = exactText(element.value);
    }
    return selected;
  }

  function preference(choice, field) {
    const value = choice[field];
    return value === undefined || value === '' ? DEFAULTS[field] : value;
  }

  function estimate(choice) {
    if (
      choice.Fabric === 'Custom Fabric (Please Contact Me First)' ||
      choice['Head Width'] === 'Custom (Please Contact Me First)' ||
      choice['Foot Width'] === 'Custom (Please Contact Me First)'
    ) return { manual: true };

    const fabric = FABRICS[choice.Fabric];
    const length = LENGTHS[choice.Length];
    const headWidth = HEAD_WIDTHS[choice['Head Width']];
    const footWidth = FOOT_WIDTHS[choice['Foot Width']];
    if (!fabric || !length || !headWidth || !footWidth) return null;

    const groundChoice = preference(choice, 'Ground Hardware');
    const hardware = GROUND_HARDWARE[groundChoice];
    const ridgelineLoops = RIDGELINE_LOOPS[preference(choice, 'Ridgeline Loops')];
    const bivyLoops = BIVY_LOOPS[preference(choice, 'Bivy Loops')];
    const glowire = GLOWIRE[preference(choice, 'Glowire')];
    const stakes = STAKES[preference(choice, 'Tent Stakes')];
    const patchKit = PATCH_KIT[preference(choice, 'Patch Kit')];
    if (
      !hardware || ridgelineLoops === undefined || bivyLoops === undefined ||
      glowire === undefined || stakes === undefined || patchKit === undefined
    ) return null;

    const rawLength = length * 12 + 3;
    const headMark = (headWidth + 6) / 2;
    const footMark = (footWidth + 6) / 2;
    const chord = Math.sqrt(rawLength * rawLength + Math.pow(headMark - footMark, 2));
    const precurveArea = rawLength * (headMark + footMark);
    const curveArea = 2.5 * chord * CONTROLS.curveFactors.ridge +
      3 * rawLength * CONTROLS.curveFactors.sides +
      2.5 * headMark * CONTROLS.curveFactors.head +
      1.5 * footMark * CONTROLS.curveFactors.foot;
    const shellArea = precurveArea - curveArea;
    const body = shellArea / 1296 * fabric.density;

    const hardwareWeight = hardware.hardware;
    const groundTies = 4 * (4.5 * hardware.grosgrain + hardwareWeight) +
      2 * (3.5 * hardware.grosgrain + hardwareWeight);
    const sealing = CONTROLS.seamSealAnchor * chord / CONTROLS.seamSealChordAnchor;
    const finished = body + CONTROLS.reinforcement + CONTROLS.ridgelineTiePair + groundTies +
      (bivyLoops ? CONTROLS.bivyLoopPair : 0) + ridgelineLoops * CONTROLS.ridgelineLoopEach + CONTROLS.assemblyTreatment + sealing;
    const sack = window.SLDEstimatorData.shared.tarps.mainSackWeight(shellArea,choice.Fabric === 'Silpoly 1.6 (Choose from available solid colors at Ripstopbytheroll.com)',0);
    const total = finished + sack + glowire + stakes + patchKit;

    return {
      body,
      finished,
      total,
      sack,
      headWidth,
      footWidth,
      reverseTaper: footWidth > headWidth
    };
  }

  function start() {
    const root = document.querySelector('[data-sld-trail-bird-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const result = estimate(selections(scope));
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');
      const note = root.querySelector('[data-sld-estimator-note]');

      if (!result || result.manual) {
        if (results) results.hidden = true;
        if (note) note.hidden = true;
        if (message) {
          message.textContent = result && result.manual
            ? 'Custom widths and fabrics require a manual weight estimate. Please contact me before ordering.'
            : 'Select your fabric, length, and both widths to see the estimated weight.';
        }
        return;
      }

      const tarpWeight = root.querySelector('[data-sld-weight-tarp]');
      const totalWeight = root.querySelector('[data-sld-weight-total]');
      if (tarpWeight) tarpWeight.textContent = result.finished.toFixed(1) + ' oz';
      if (totalWeight) totalWeight.textContent = result.total.toFixed(1) + ' oz';
      if (results) results.hidden = false;
      if (message) message.textContent = '';
      if (note) note.hidden = !result.reverseTaper;
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return { estimate, selections, start };
});
